import { DependencyList, useEffect, useState } from 'react';

interface UseStatefulAsyncEffectReturns<T> {
  loading: boolean;
  error: null | unknown;
  data: null | T;
}

export function useStatefulAsyncEffect<T>(
  asyncEffectFn: () => Promise<T>,
  deps: DependencyList
): UseStatefulAsyncEffectReturns<T> {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<null | unknown>(null);
  const [data, setData] = useState<null | T>(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    asyncEffectFn()
      .then((res) => {
        if (!mounted) return;
        setData(res);
      })
      .catch((err) => {
        if (!mounted) return;
        setError(err);
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
    // cannot be staticly verified when passed in
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return {
    loading,
    error,
    data,
  };
}
